import { render, staticRenderFns } from "./d-activity-unfollow-user.vue?vue&type=template&id=2de6ca31&"
import script from "./d-activity-unfollow-user.vue?vue&type=script&lang=js&"
export * from "./d-activity-unfollow-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports